<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/9kkK7s/tc-custom/9781400852529.jpg?1731429761900" alt="This image is the cover for the book Speech Matters, Carl G. Hempel Lecture Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Speech Matters, Carl G. Hempel Lecture Series
      </h1>
      <p class="bookDescription body article font2">
        <p>To understand one another as individuals and to fulfill the moral duties that require such understanding, we must communicate with each other. We must also maintain protected channels that render reliable communication possible, a demand that, Seana Shiffrin argues, yields a prohibition against lying and requires protection for free speech. This book makes a distinctive philosophical argument for the wrong of the lie and provides an original account of its difference from the wrong of deception.<br/><br/>Drawing on legal as well as philosophical arguments, the book defends a series of notable claims—that you may not lie about everything to the "murderer at the door," that you have reasons to keep promises offered under duress, that lies are not protected by free speech, that police subvert their mission when they lie to suspects, and that scholars undermine their goals when they lie to research subjects.<br/><br/>Many philosophers start to craft moral exceptions to demands for sincerity and fidelity when they confront wrongdoers, the pressures of non-ideal circumstances, or the achievement of morally substantial ends. But Shiffrin consistently resists this sort of exceptionalism, arguing that maintaining a strong basis for trust and reliable communication through practices of sincerity, fidelity, and respecting free speech is an essential aspect of ensuring the conditions for moral progress, including our rehabilitation of and moral reconciliation with wrongdoers.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Seana Valentine Shiffrin
      </h2>
      
      <p class="authorDescription body article"><B>Seana Valentine Shiffrin</B> is professor of philosophy and the Pete Kameron Professor of Law and Social Justice at the University of California, Los Angeles.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Princeton University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?9aa4ff6a